import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";

function VenuesWithOrdersWithoutSubscriptions(props) {
  const [rows, setRows] = useState(null);
  const [paginationData, setPaginationData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  useEffect(() => {
    axios.post(`core/SubsDashboard/venuesWithOrdersAndWithoutSubscriptions`).then((response) => {
      let venues = response.data.data.venues; //.map((venue) => Venue.CreateModel(venue));
      const subsSubscriptionsMap = {};
      response.data.data.subs_subscriptions.forEach((subsSubscription) => {
        if (!subsSubscriptionsMap[subsSubscription.venue_id]) {
          subsSubscriptionsMap[subsSubscription.venue_id] = { subs_subscriptions: [] };
        }
        subsSubscriptionsMap[subsSubscription.venue_id].subs_subscriptions.push(subsSubscription);
      });
      venues = venues.filter((venue) => {
        venue.subs_subscriptions = subsSubscriptionsMap[venue.id]?.subs_subscriptions ?? [];

        const now = new Date();

        venue.subs_subscriptions = venue.subs_subscriptions.filter((subsSubscription) => {
          if (subsSubscription.start_date_unix * 1000 < now.getTime()) {
            if (subsSubscription.end_date_unix == null || subsSubscription.end_date_unix * 1000 > now.getTime()) {
              return true;
            }
          }
          return false;
        });

        return !venue.subs_subscriptions.some((subsSubscription) => {
          if (subsSubscription.status_invoicing === "ACTIVE") {
            return true;
          } else {
            return false;
          }
        });
      });

      venues = venues.sort((a, b) => {
        return b.number_of_orders > a.number_of_orders ? 1 : b.number_of_orders < a.number_of_orders ? -1 : 0;
      });

      setPaginationData({
        total: venues.length,
      });
      setRows(venues);
    });
  }, []);

  return (
    <Card>
      <CardHeader title={"Venues met bestellingen zonder actieve abonnementen"} />
      <CardContent style={{ textAlign: "center" }}>
        {rows != null ? (
          <>
            <Table size={"small"}>
              <TableHead>
                <TableRow style={{ fontWeight: 800 }}>
                  <TableCell style={{ fontWeight: 800 }}>Count</TableCell>
                  <TableCell style={{ fontWeight: 800 }}>#</TableCell>
                  <TableCell style={{ fontWeight: 800 }}>Venue</TableCell>
                  <TableCell style={{ fontWeight: 800 }}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((venue) => {
                  return (
                    <TableRow key={venue.id}>
                      <TableCell>{venue.number_of_orders}</TableCell>
                      <TableCell>{venue.id}</TableCell>
                      <TableCell>{venue.name}</TableCell>
                      <TableCell>
                        {venue.subs_subscriptions.length == 0 ? "No subscription" : "Not an active subscription"}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              component={"div"}
              count={paginationData?.total}
              onPageChange={(e, newPage) => {
                setPage(newPage);
              }}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value));
              }}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
              showFirstButton
              showLastButton
            />
          </>
        ) : null}
        {rows == null ? <CircularProgress /> : null}
      </CardContent>
    </Card>
  );
}

export default VenuesWithOrdersWithoutSubscriptions;
